import { ArrowRight, Plus } from 'lucide-react'
import { MockShell } from './MockShell'

const SCENARIOS = [
  {
    name: 'Göni',
    route: 'Rotterdam → Warsaw',
    km: '1,240 km',
    trucks: '1 sowadyjy',
    price: '€ 1,413',
    margin: '22%',
    active: true,
  },
  {
    name: 'Geçiş · Berlin',
    route: 'Rotterdam → Berlin → Warsaw',
    km: '1,310 km',
    trucks: '1 sowadyjy + xdock',
    price: '€ 1,295',
    margin: '17%',
    active: false,
  },
  {
    name: 'Bölünen · 2 ulag',
    route: 'Rotterdam → Warsaw',
    km: '2 × 1,240 km',
    trucks: '2 ýapyk furgon',
    price: '€ 1,620',
    margin: '24%',
    active: false,
  },
]

export function ScenarioMock() {
  return (
    <MockShell title="Baha Q-2417 · Senariýalar">
      <div className="p-5">
        <div className="flex items-center justify-between mb-4">
          <p className="text-overline text-muted-foreground">3 senariýa</p>
          <button className="inline-flex items-center gap-1 text-[12px] font-medium text-primary">
            <Plus className="w-3 h-3" /> Senariýa goş
          </button>
        </div>

        <div className="space-y-2">
          {SCENARIOS.map((s) => (
            <div
              key={s.name}
              className={
                'rounded-xl border p-4 transition-colors ' +
                (s.active
                  ? 'border-primary bg-primary/5'
                  : 'border-border bg-background hover:bg-muted/40')
              }
            >
              <div className="flex items-center justify-between gap-3 mb-2">
                <div className="flex items-center gap-2">
                  <span
                    className={
                      'w-2 h-2 rounded-full ' +
                      (s.active ? 'bg-primary' : 'bg-muted-foreground/40')
                    }
                  />
                  <p className="text-[13px] font-semibold">{s.name}</p>
                </div>
                <span className="tnum text-[13px] font-semibold">{s.price}</span>
              </div>
              <div className="flex items-center justify-between text-[11.5px] text-muted-foreground">
                <span className="inline-flex items-center gap-1.5">
                  {s.route} <ArrowRight className="w-3 h-3" /> {s.km}
                </span>
                <span>
                  {s.trucks} · marja <span className="text-positive">{s.margin}</span>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </MockShell>
  )
}
